import React, { useState } from 'react';

const OperarioSelectionModal = ({ operarios, onSelect, onClose }) => {
  const [selectedOperarioId, setSelectedOperarioId] = useState('');
  const [message, setMessage] = useState('');

  const handleConfirm = () => {
    if (!selectedOperarioId) {
      setMessage('Por favor, selecciona un operario.');
      return;
    }
    onSelect(selectedOperarioId);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-4 z-50">
      <div className="bg-white p-6 rounded-2xl shadow-xl max-w-md w-full transform transition-all scale-100 opacity-100 duration-300">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Seleccionar Operario</h2>
        <div className="mb-6">
          <label className="block text-gray-700 text-base font-medium mb-3">Operario:</label>
          <div className="grid grid-cols-2 gap-3"> {/* Grid para los botones de operarios */}
            {operarios.map(op => (
              <button
                key={op.id}
                onClick={() => {
                  setSelectedOperarioId(op.id);
                  setMessage('');
                }}
                className={`py-3 px-4 rounded-lg font-semibold transition-colors text-base border-2 ${
                  selectedOperarioId === op.id
                    ? 'bg-indigo-600 text-white border-indigo-600 ring-2 ring-indigo-500' // Estilo seleccionado
                    : 'bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-200'
                }`}
              >
                {op.nombre}
              </button>
            ))}
          </div>
          {message && <p className="text-red-500 text-sm mt-3 text-center">{message}</p>}
        </div>
        <div className="flex flex-col space-y-2 sm:flex-row sm:space-x-2 sm:space-y-0 justify-end">
          <button
            onClick={onClose}
            className="flex-1 py-3 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition-colors font-semibold text-base"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirm}
            className="flex-1 bg-black text-white py-3 rounded-lg hover:bg-gray-800 transition-colors font-semibold text-base"
          >
            Asignar y Iniciar
          </button>
        </div>
      </div>
    </div>
  );
};

export default OperarioSelectionModal;